<template>
  <div class="mt-25">
    <router-view/>
    <coming-soon-modal
        v-if="comingSoonModalVisible"
        :visible="comingSoonModalVisible"
        @modal-close="comingSoonModalVisible = false"
    />
  </div>
</template>

<script>

import ComingSoonModal from '@/components/pre-paywall-pages/recruiter/ComingSoonModal';

export default {
  name: 'PrePaywallPage',
  components: {
    ComingSoonModal,
  },
  data: function () {
    return {
      comingSoonModalVisible: false,
    };
  },
  mounted: function () {
    this.$root.$on('show-coming-soon-modal', this.showComingSoonModal);
  },
  beforeDestroy: function () {
    this.$root.$off('show-coming-soon-modal');
  },
  methods: {
    showComingSoonModal: function () {
      this.comingSoonModalVisible = true;
    },
  }
};
</script>

<style scoped>
.mt-25{
  margin-top:25px !important;
}
</style>